<template>
  <div class="medical-record-default-item">
    <div v-if="hasAnthropometry" class="mb-2">
      <div v-if="item.anthropometry.height">
        <strong>Altura:</strong> {{ item.anthropometry.height }} cm
      </div>
      <div v-if="item.anthropometry.weight">
        <strong>Peso:</strong> {{ item.anthropometry.weight }} kg
      </div>
    </div>

    <template v-for="(value, name) in item.anamnesis.inputs">
      <st-data-display :label="getInputLabel(name)" v-if="value" :key="name">
        <div class="text-pre" v-html="sanitizeHTML(value)" />
      </st-data-display>
    </template>

    <st-data-display label="CID" v-if="hasCIDs">
      <div v-for="(item, idx) in item.cids" :key="idx">
        <strong class="item-label">{{ item.code }}</strong>
        <small>-</small>
        <span class="ml-1">{{ item.name }}</span>
      </div>
    </st-data-display>
  </div>
</template>

<script>
import { sanitize as sanitizeHTML } from '@/helpers/html';

export default {
  props: {
    item: {
      type: Object,
    },
  },
  data() {
    return {
      sanitizeHTML,
    };
  },
  computed: {
    hasAnthropometry() {
      return this.item.anthropometry.height || this.item.anthropometry.weight;
    },
    hasCIDs() {
      return Array.isArray(this.item.cids) && this.item.cids.length > 0;
    },
  },
  methods: {
    getInputLabel(name) {
      const labels = {
        subjective: 'Subjetivo',
        objective: 'Objetivo',
        assessment: 'Avaliação',
        plan: 'Plano',
        content: 'Anamneses / evolução',
      };
      return labels[name] || '';
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";

.medical-record-default-item {
  .item-label {
    color: $dark-blue-color-500;
    font-weight: 600;
    margin-right: $layout-spacing-sm;
  }
}
</style>
